import React from "react";
import PropTypes from "prop-types";

import { OrderObject } from "./../Queries/OrderQuery";

class PauseEpiSyncBtn extends React.Component {
  handleClick = () => {
    const { order } = this.props;
    const isDisabled = order.epiSyncDisabled;
    const message = isDisabled
      ? "Are you sure you want to enable syncing this order back to EPI?"
      : "Are you sure you want to stop syncing this order back to EPI?";

    if (window.confirm(message)) {
      this.toggleEpiSync();
    }
  };

  toggleEpiSync = () => {
    const { update, order } = this.props;
    update({
      variables: {
        id: order.id
      }
    });
  };

  render() {
    const { order } = this.props;
    const isDisabled = order.epiSyncDisabled;
    const buttonText = isDisabled ? "Enable EPI Sync" : "Pause EPI Sync";
    const buttonClass = isDisabled
      ? "button red"
      : "button button--white";

    return (
      <button className={buttonClass} onClick={this.handleClick}>
        {buttonText}
      </button>
    );
  }
}

PauseEpiSyncBtn.propTypes = {
  order: OrderObject.isRequired,
  update: PropTypes.func.isRequired
};

export default PauseEpiSyncBtn;
